import React from "react";
import { useClientAuthInternal, ClientAuthContext } from "@/hooks/useClientAuth";
import { useActivityTracker } from "@/hooks/useActivityTracker";
import ClientAuthPage from "@/components/ClientAuthPage";

interface ClientAuthWrapperProps {
  children: React.ReactNode;
}

const ClientAuthWrapper: React.FC<ClientAuthWrapperProps> = ({ children }) => {
  const auth = useClientAuthInternal();

  // Activer le tracking de l'activité pour les clients authentifiés
  useActivityTracker(auth.isAuthenticated, auth.clientId, auth.email);

  // Affichage de chargement
  if (auth.loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Vérification de l'authentification...</p>
        </div>
      </div>
    );
  }

  // Si l'authentification est requise mais que l'utilisateur n'est pas authentifié
  if (auth.requiresAuth && !auth.isAuthenticated) {
    return (
      <ClientAuthContext.Provider value={auth}>
        <ClientAuthPage />
      </ClientAuthContext.Provider>
    );
  }

  // Utilisateur authentifié ou pas d'authentification requise, afficher le contenu
  return (
    <ClientAuthContext.Provider value={auth}>
      {children}
    </ClientAuthContext.Provider>
  );
};

export default ClientAuthWrapper;
